/**
 * @file The Qty cell of one staged row. Consumer: `SignifyFetchJobInputTable`, which hands it the
 * row's proxy so a quantity edit re-renders this cell and nothing else.
 * The quantity travels with the part to the job and ends up in the inserted row's `quantity` cell,
 * never on the Products record — a record is upserted by product id and the next BOM would
 * overwrite it. Where the target table has no Quantity column the input is disabled rather than
 * hidden, with the reason on the control and on the column header.
 * A cleared field is `null`, which reads as the default of one.
 */

import { FC } from 'react';
import { InputNumber } from 'antd';
import { useSnapshot } from 'valtio';
import type { SignifyFetchJobDraftInput } from '../index.types';

type SignifyFetchJobInputQuantityCellProps = {
  row: SignifyFetchJobDraftInput;
  disabledReason: string | null;
};

const SignifyFetchJobInputQuantityCell: FC<SignifyFetchJobInputQuantityCellProps> = ({
  row,
  disabledReason,
}) => {
  const snap = useSnapshot(row);

  return (
    <InputNumber
      size="small"
      min={1}
      step={1}
      precision={0}
      controls={false}
      style={{ width: '100%' }}
      disabled={!!disabledReason}
      aria-label={
        disabledReason
          ? `signify-fetch-job-quantity-${row.key} (${disabledReason})`
          : `signify-fetch-job-quantity-${row.key}`
      }
      value={snap.quantity}
      onChange={(value) => {
        row.quantity = value ?? 1;
      }}
    />
  );
};

export default SignifyFetchJobInputQuantityCell;
